var SpaceType;
(function (SpaceType) {
    SpaceType["Unit"] = "unit";
    SpaceType["Amenity"] = "amenity";
    SpaceType["Other"] = "other";
})(SpaceType || (SpaceType = {}));
var NodeLinkType;
(function (NodeLinkType) {
    NodeLinkType["Node"] = "node";
    NodeLinkType["Space"] = "space";
})(NodeLinkType || (NodeLinkType = {}));
var HotspotType;
(function (HotspotType) {
    HotspotType["Info"] = "info";
    HotspotType["Node"] = "node";
    HotspotType["Space"] = "space";
})(HotspotType || (HotspotType = {}));
var PublishGmbStatus;
(function (PublishGmbStatus) {
    PublishGmbStatus["Unpublished"] = "unpublished";
    PublishGmbStatus["Published"] = "published";
    PublishGmbStatus["Processing"] = "processing";
})(PublishGmbStatus || (PublishGmbStatus = {}));

export { HotspotType, NodeLinkType, PublishGmbStatus, SpaceType };
